import React from "react";
import { observer } from "mobx-react-lite";
import { Show } from "Components";
import { Box } from "Components";

import { WeeklyRotaDetailsViewModel } from "../WeeklyRotaDetailViewModel";
import { ScheduleChartHeader } from "./Components/ScheduleChartHeader";
import { ScheduleChartRow } from "./Components/ScheduleChartRow";
import AddStudentView from "../AddStudent/AddStudentView";
import StudentRotaDetailView from "../StudentRotaDetail/StudentRotaDetailView";
import OverTimeConfirmationPopup from "../AddStudent/OverTimeConfirmationPopup";
import { MentorRowsContainer, StickyHeaderOuter } from "./ScheduleChart.styles";

export interface ScheduleChartProps {
    viewModel: WeeklyRotaDetailsViewModel;
}

const ScheduleChart: React.FC<ScheduleChartProps> = observer(({ viewModel }) => (
    <>
        <ChartGrid viewModel={viewModel} />
        <ChartModals viewModel={viewModel} />
    </>
));

export default ScheduleChart;

interface ChartSectionProps {
    viewModel: WeeklyRotaDetailsViewModel;
}

const ChartGrid: React.FC<ChartSectionProps> = observer(({ viewModel }) => (
    <Box>
        <StickyHeaderOuter>
            <ScheduleChartHeader />
        </StickyHeaderOuter>
        <MentorRows viewModel={viewModel} />
    </Box>
));

const MentorRows: React.FC<ChartSectionProps> = observer(({ viewModel }) => (
    <MentorRowsContainer>
        {viewModel.mentorAvailabilityList.map((mentor, index) => (
            <ScheduleChartRow key={mentor.mentorId} mentor={mentor} viewModel={viewModel} index={index} />
        ))}
    </MentorRowsContainer>
));

const ChartModals: React.FC<ChartSectionProps> = observer(({ viewModel }) => (
    <>
        <Show if={viewModel.showAddStudentModal}>
            <AddStudentView viewModel={viewModel.addStudentViewModel} parentViewModel={viewModel} onCancel={viewModel.closeAddStudentModalCommand.execute} />
        </Show>
        <Show if={viewModel.openOverTimeConfirmationModal}>
            <OverTimeConfirmationPopup closeCommand={viewModel.closeOverTimeConfirmationModalCommand} proceedCommand={viewModel.openAddStudentAfterOverTimeCommand} />
        </Show>
        <Show if={viewModel.openStudentDetailModal}>
            <StudentRotaDetailView viewModel={viewModel} closeCommand={viewModel.closeStudentDetailModalCommand} />
        </Show>
    </>
));
